class Fun{
	constructor(){
		this.mall_path='https://www.desigual.com/en_HK'
	}
	back(){

		window.history.go(-1)




	}
	toPage(path,type){
		const pageFun={
			assign:(path)=>{
				if(path){
					location.assign(path)
				}else{
					location.assign(this.mall_path)
				}
			}
		}
		if(!type){
			uni.navigateTo({
				url:path
			})
		}else if(pageFun[type]){
			pageFun[type](path)
		}else{
			console.log('No such attribute');
		}
	}
	timestampToTime(timestamp){
		timestamp-=1000*60*60*7
		timestamp = timestamp ? timestamp : null;
		let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
		let Y = date.getFullYear() + '-';
		let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
		let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
		let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
		let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
		let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
		return Y + M + D + h + m + s;
	}
}
let fun =new Fun()
export default fun